import Verify from "./verify";

export default Verify;
